import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import { Checkbox, DialogContent, FormControl, FormControlLabel, Stack, TextField, Box } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux/features/rootSlice";
import { getUserInfo, updateTimezone } from "../../redux/features/user.slice";
import useWebSocket from "../../hooks/useWebSocket";
import { webSocketMessage } from "../../config/app";

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  user?: {
    id: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    newpassword: string;
    oldpassword: string;
    language: string;
    timezone: string;
  };
}

const timeZoneOptions = [
  { label: 'GMT + 05:30 Asia/Kolkata' },
  { label: 'GMT - 05:00 United States' },
  { label: 'GMT + 06:00 Asia/Kolkata' }
];

const TimeZoneUpdate = (props: DialogProps) => {
  const { open, onClose, user } = props;
  const dispatch = useDispatch();
  const { updateUserAndNotifyParent } = useWebSocket();
  const timezoneLoading = useSelector(
    (state: RootStateType) => state.userStateReducer.loading
  );
 // const [timezone, setTimezone] = React.useState(timeZoneOptions[0]);
  const [timezone, setTimezone] = React.useState<{ label: string } | null>(timeZoneOptions[0]);
  const [buttonEnabled,setButtonEnabled] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: { label: string } | null) => {
    setTimezone(newValue);
  };
  const handleListItemClick = async () => {
        // Handle the list item click event here
        const dispatchObj = {
          timezone: {
            timezone: timezone?.label
          },
          callBackSuccess: () => {
            updateUserAndNotifyParent(webSocketMessage.timezoneResponse);
            onClose();
            dispatch(getUserInfo());
            setButtonEnabled(false);
          },
        };
        dispatch(updateTimezone(dispatchObj));
  };

  const dialogClose = () => {
    onClose();
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick();
    }
  };

  useEffect(() => {
    if (user?.timezone) {
      setTimezone({ label: user.timezone });
    } else {
      setTimezone(null);
    }
  }, [user]);

  useEffect(() => {
    const timezoneLabel = timezone?.label;
    const userTimezone = user?.timezone;
    const isLanguageValid = timeZoneOptions.some(t => t.label === timezoneLabel);

    if (!timezoneLabel || !isLanguageValid || timezoneLabel === userTimezone) {
      setButtonEnabled(false);
    } else {
      setButtonEnabled(true);
    }
  }, [timezone]);

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Change time zone"}
        buttonText={"Update"}
        buttonClick={handleListItemClick}
        open={open}
        isLoading={timezoneLoading}
        isBtnEnabled={!buttonEnabled}
        style={{ maxWidth: 500, mx: "auto" }}
      >
        <DialogContent>
          <Stack gap={2}>
            <FormControl size="small" color="secondary">
              <Autocomplete
                id="timezone-select"
                options={timeZoneOptions}
                value={timezone}
                onChange={handleChange}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select time zone"
                    variant="outlined"
                    fullWidth
                    onKeyDown={handleKeyDown}
                    onChange={(e)=>{
                    setTimezone({label: e.target.value})
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.label}
                  </Box>
                )}
              />
            </FormControl>
            {/* <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={addressDetails.isdefault}
                    onChange={(e) =>
                      setAddressDetails({
                        ...addressDetails,
                        isdefault: e.target.checked,
                      })
                    }
                  />
                }
                label="Set automatically"
              />
            </Box> */}
            {/* <FormControlLabel control={<Checkbox defaultChecked />} label="Set automatically" /> */}
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default TimeZoneUpdate;
